export default class Background {
    texture;
    backgroundColor;
    borderThickness;
    borderColor;

    constructor(properties) {
        this.texture = properties.backgroundImage || null;
        this.borderThickness = properties.borderThickness || 2;
        this.backgroundColor = Object.assign(
            {r: 0, g: 0, b: 0, a: 0.3},
            properties.backgroundColor
        );

        this.borderColor = Object.assign(
            {r: 0, g: 0, b: 0, a: 0.7},
            properties.borderColor
        );
    }

    updateBackground(texture, backgroundColor, borderThickness, borderColor) {
        this.texture = texture || this.texture;
        this.backgroundColor = backgroundColor || this.backgroundColor;
        this.borderThickness = borderThickness || this.borderThickness;
        this.borderColor = borderColor || this.borderColor;
    }
}